import { ChooseItemsStep } from './choose-items-step/choose-items-step';
import { ConfigureReturnStep } from './configure-return-step/configure-return-step';

export const newReturnSteps = [ChooseItemsStep, ConfigureReturnStep];
